define((require) => {
    "use strict";

    const Enum                   = require("shared/util/Enum");
    const OpacityEffectModel     = require("shared/ui/experience/action/effects/OpacityEffectModel");
    const ScaleEffectModel       = require("shared/ui/experience/action/effects/ScaleEffectModel");
    const RotateEffectModel      = require("shared/ui/experience/action/effects/RotateEffectModel");
    const PulseEffectModel       = require("shared/ui/experience/action/effects/PulseEffectModel");
    const ImageToggleEffectModel = require("shared/ui/experience/action/effects/ImageToggleEffectModel");

    /**
     * A enum describing all effect model types, where each type can have numerous instances. <p>
     *
     * The returned enum will index each effect model via is static defined <tt>TYPE</tt> property, e.g.
     * {.., ScaleEffectModel.TYPE: ScaleEffectModel, ..}, where the described value of the key in this
     * example is "scale".
     */
    return Enum.create("EffectModel", "TYPE", [
        OpacityEffectModel,
        ScaleEffectModel,
        RotateEffectModel,
        PulseEffectModel,
        ImageToggleEffectModel
    ]);
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/action/effects/EffectModels.js